export default async function negotiateConnectionWithClientOffer(
  peerConnection: RTCPeerConnection,
  endpoint: string
): Promise<string | null> {
  const offer = await peerConnection.createOffer();
  await peerConnection.setLocalDescription(offer);
  const ofr = await waitToCompleteICEGathering(peerConnection);
  if (!ofr) throw new Error('Failed to gather ICE candidates for offer');

  while (peerConnection.connectionState !== 'closed') {
    const response = await postSDPOffer(endpoint, ofr.sdp!);
    if (response.status === 201) {
      const answerSDP = await response.text();
      await peerConnection.setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: answerSDP }));
      return response.headers.get('Location');
    } else if (response.status === 405) {
      console.error('Update the URL passed into the WHIP or WHEP client');
    } else {
      console.error(await response.text());
    }
    await new Promise(r => setTimeout(r, 5000));
  }
  return null;
}

async function postSDPOffer(endpoint: string, data: string): Promise<Response> {
  return fetch(endpoint, {
    method: 'POST',
    mode: 'cors',
    headers: { 'content-type': 'application/sdp' },
    body: data,
  });
}

async function waitToCompleteICEGathering(peerConnection: RTCPeerConnection): Promise<RTCSessionDescriptionInit | null> {
  return new Promise(resolve => {
    setTimeout(() => resolve(peerConnection.localDescription!), 1000);
    peerConnection.onicegatheringstatechange = () => {
      if (peerConnection.iceGatheringState === 'complete') resolve(peerConnection.localDescription!);
    };
  });
}